module.exports = __webpack_public_path__ + "static/media/man.dabcdaa2.svg";